module.exports = __webpack_public_path__ + "img/masu.2ff8ba23.jpg";